import { useEffect, useState } from 'react';

// Track scroll progress (0..1) and write to CSS variable for parallax effects.
export const useScrollProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const doc = document.documentElement;
        const scrollTop = doc.scrollTop || window.pageYOffset;
        const max = (doc.scrollHeight || 1) - (window.innerHeight || 1);
        const value = max > 0 ? Math.min(scrollTop / max, 1) : 0;
        setProgress(value);
        if (!prefersReducedMotion) {
          doc.style.setProperty('--page-progress', value.toString());
        }
        ticking = false;
      });
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return progress;
};

export default useScrollProgress;
